import { APP_FEEDBACK } from "api/ApiPath";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import client from "api/client";
import { injectable } from "tsyringe";
import { AppFeedbackResponseModel } from "./model/AppFeedbackResponseModel";
import { IAppFeedbackRepository } from "../domain/repositories/IAppFeedbackRepository";
import { AppFeedbackRequestModel } from "./model/AppFeedbackRequestModel";

@injectable()
export class AppFeedbackImpl implements IAppFeedbackRepository {
  async getList(
    params: AppFeedbackRequestModel,
  ): Promise<ListBaseApiResponseModel<AppFeedbackResponseModel>> {
    return await client?.get(APP_FEEDBACK.LIST, params);
  }

  async getDetail(
    id: string,
  ): Promise<BaseApiResponseModel<AppFeedbackResponseModel>> {
    return await client?.get(`${APP_FEEDBACK.DETAIL}/${id}`);
  }
}
